import React from "react";
import Navigation from "../../Templates/Navigation/Navigation";
import Footer from "../../Templates/Footer/Footer";
import BlogPage from "../../Templates/BlogPage/BlogPage";

const BlogScreen = () => {
  return (
    <>
      <Navigation />
      <BlogPage />
      <Footer />
    </>
  );
};

export default BlogScreen;
